import TokenService from "./token.service";


export const imgConfig = {
    headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${TokenService.getToken()}`
    }
}